import React from "react";
import { TiDownload } from "react-icons/ti";

export const ExportIcon = (props) => {
  return <TiDownload {...props} />;
};
